import { Grid, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { ProformaEmployeeCostReportSectionRef } from "../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import { Header, StyledTable, StyledTableHead } from "../styles";
import ExportedProformaEmployeeCostReportSection from "./ExportedProformaEmployeeCostReportSection";

interface Props {
  paySchemaSections: ProformaEmployeeCostReportSectionRef[];
  monthlyView: boolean;
}

const ExportedProformaEmployeeCostReportPaySchema = ({ paySchemaSections, monthlyView }: Props) => {
  return (
    <>
      <Grid style={{ width: "48%" }}>
        <StyledTable size="small">
          <StyledTableHead>
            <TableRow>
              <Header colSpan={3}>
                <Typography>Employee pay schema</Typography>
              </Header>
            </TableRow>
            <TableRow>
              <TableCell align="center">Section</TableCell>
              <TableCell align="center">Rate</TableCell>
              <TableCell align="center">
                Amount
                {monthlyView && <Typography variant="body2">(Monthly)</Typography>}
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {paySchemaSections.map((section, idx) => (
              <ExportedProformaEmployeeCostReportSection
                key={idx}
                section={section}
                monthlyView={monthlyView}
              />
            ))}
          </TableBody>
        </StyledTable>
      </Grid>
    </>
  );
};
export default ExportedProformaEmployeeCostReportPaySchema;
